/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';

type PatternsData = Partial<OmitFunctions<Omit<PatternStore, 'id'>>>;

export class PatternStore {
    public id: string;

    @observable public text: string;

    @observable public intentId: string;

    constructor(id: string, data: PatternsData) {
        this.id = id;
        this.text = data.text;
        this.intentId = data.intentId;
    }

    /**
     * Sets the text of the pattern.
     *
     * @param text The new text.
     */
    @action
    public setText(text: string): void {
        this.text = text;
    }

    /**
     * Sets the intent id of the pattern.
     *
     * @param intentId The intent id to assign to the pattern.
     */
    @action
    public setIntentId(intentId: string): void {
        this.intentId = intentId;
    }
}
